import { IntegrationFeature, IntegratorItem } from "components/ranked-table/types";

export enum DesignIntegrators {
  AERIALYTIC = "Aerialytic",
  AURORA = "Aurora",
  SOLO = "Solo",
  EVERBRIGHT = "Everbright (Sighten)",
  HELIOQUOTE = "HelioQuote",
  MANUAL_DESIGN = "Manual Design",
}

const integrators: { [key in DesignIntegrators]: IntegratorItem } = {
  [DesignIntegrators.AERIALYTIC]: {
    _id: DesignIntegrators.AERIALYTIC,
    name: DesignIntegrators.AERIALYTIC,
    orderRank: "1",
  },
  [DesignIntegrators.AURORA]: {
    _id: DesignIntegrators.AURORA,
    name: DesignIntegrators.AURORA,
    orderRank: "2",
  },
  [DesignIntegrators.SOLO]: {
    _id: DesignIntegrators.SOLO,
    name: DesignIntegrators.SOLO,
    orderRank: "3",
  },
  [DesignIntegrators.EVERBRIGHT]: {
    _id: DesignIntegrators.EVERBRIGHT,
    name: DesignIntegrators.EVERBRIGHT,
    orderRank: "4",
  },
  [DesignIntegrators.HELIOQUOTE]: {
    _id: DesignIntegrators.HELIOQUOTE,
    name: DesignIntegrators.HELIOQUOTE,
    orderRank: "5",
  },
  [DesignIntegrators.MANUAL_DESIGN]: {
    _id: DesignIntegrators.MANUAL_DESIGN,
    name: DesignIntegrators.MANUAL_DESIGN,
    orderRank: "6",
  },
};
export const defaultDesignAppsList = Object.values(integrators).sort(
  (a, b) => Number(a.orderRank) - Number(b.orderRank)
);

export const defaultDesignFeatures: IntegrationFeature[] = [
  {
    title: "Start the Design Process within Enerflo",
    description: "Initiate a design request within Enerflo for the design tool",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
  {
    title: "Instant AI Design",
    description: "Automatic AI modeling of rooftops without requiring a human designer",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
    ],
  },
  {
    title: "DIY Design",
    description: "Allow the sales rep to build their own design from scratch",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
    ],
  },
  {
    title: "Turn Around Time",
    description: "Speed to get a design built and ready for a proposal",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id }, detail: "30 seconds" },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id }, detail: "60 seconds" },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id }, detail: "10 minutes" },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id }, detail: "7 minutes" },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id }, detail: "10 minutes" },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id }, detail: "Varies" },
    ],
  },
  {
    title: "Add/Remove Trees or Roof Planes",
    description: "Allow for trees to be added/removed in real-time",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
    ],
  },
  {
    title: "Complete Raw Data Set",
    description: "Complete data set including production by array, roof measurements, tilt, azimuth etc",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
    ],
  },
  {
    title: "Sync Consumption Data",
    description: "Configure consumption data within Enerflo",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
  {
    title: "Multiple Consumption Profiles",
    description: "Selection of alternative consumption profile supported",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
  {
    title: "Ground Mounts",
    description: "Get designs back for ground mounts or where there is no imagery",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
  {
    title: "Design Versioning",
    description: "Sync multiple versions of a design without requesting a new design",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
  {
    title: "3D Modeling",
    description: "Design returned with a 3D model rendering",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
    ],
  },
  {
    title: "Add/Remove Panels in Enerflo's Proposal Tool (Optimus)",
    description: "Ability to make panel modifications within the proposal via iframe",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
  {
    title: "Design Auto Sync",
    description: "Update the design in Enerflo when modifications are made in the design tool",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
    ],
  },
  {
    title: "Equipment Changes",
    description: "Ability to change equipment on the fly without a redesign",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
    ],
  },
  {
    title: "User Validation",
    description: "Ensure sales reps have user rights in the integrated design tool",
    integrators: [
      { item: { _ref: integrators[DesignIntegrators.AERIALYTIC]._id } },
      { item: { _ref: integrators[DesignIntegrators.AURORA]._id } },
      { item: { _ref: integrators[DesignIntegrators.SOLO]._id } },
      { item: { _ref: integrators[DesignIntegrators.EVERBRIGHT]._id } },
      { item: { _ref: integrators[DesignIntegrators.HELIOQUOTE]._id } },
      { item: { _ref: integrators[DesignIntegrators.MANUAL_DESIGN]._id } },
    ],
  },
];
